import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';

import myImagePath from '../../../assets/images/bg-form.jpg';

const FormWrapper = styled.div`
  background: url(${myImagePath});
  background-repeat: repeat;
  background-size: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;

  form {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

interface FormBackgroundProps {
  children: ReactNode;
}

const FormBackground: FC<FormBackgroundProps> = ({ children }) => {
  return <FormWrapper>{children}</FormWrapper>;
};

export default FormBackground;
